// Pobierz element HTML, w którym będą wyświetlane posty
const postContainer = document.querySelector('#post-container');

// Definiujemy hashtagi, których będziemy używać do filtrowania
const hashtags = {
  all: '#galeria',
  artCakes: '#tort',
  meringue: '#beza',
  wedding: '#weddingcake',
  pie: '#ciastazielonagóra',
  dessert: '#deser',
  candyBar: '#candybar',
};

function displayPosts(hashtag) {
  postContainer.innerHTML = ''; // Wyczyść kontener przed dodaniem nowych postów

  // Dodaj placeholdery
  for (let i = 0; i < 6; i++) {
    const skeletonDiv = document.createElement('div');
    skeletonDiv.classList.add('skeleton', 'col-12', 'col-sm-6', 'col-lg-4');
    postContainer.appendChild(skeletonDiv);
  }

  // Sprawdź, czy posty są zapisane w sessionStorage
  const cachedData = sessionStorage.getItem('cachedPosts');

  if (cachedData) {
    // Jeśli posty są zapisane w sessionStorage, odczytaj i wyświetl je
    const data = JSON.parse(cachedData);
    renderPosts(data, hashtag);
  } else {
    // Pobierz posty z serwera i zapisz je w sessionStorage
    fetch('/.netlify/functions/getPosts')
      .then(response => response.json())
      .then(data => {
        sessionStorage.setItem('cachedPosts', JSON.stringify(data)); // Zapisz dane w sessionStorage
        renderPosts(data, hashtag); // Wyświetl pobrane posty

      })
      .catch(error => console.error('Błąd w pobieraniu postów:', error));
  }
}

function renderPosts(posts, hashtag) {
  postContainer.innerHTML = ''; // Wyczyść kontener na posty

  // Iteracja przez posty i tworzenie ich elementów
  posts.forEach(post => {
    if (hashtag === '' || (post.caption && post.caption.includes(hashtag))) {
      // Tworzenie elementu posta
      const postDiv = document.createElement('div');
      postDiv.classList.add('item'); // Klasa zgodna z układem masonry

      // Blok cytatu dla osadzania Instagrama
      const blockquote = document.createElement('blockquote');
      blockquote.classList.add('instagram-media');
      blockquote.setAttribute('data-instgrm-permalink', post.permalink);
      blockquote.setAttribute('data-instgrm-version', '16');

      postDiv.appendChild(blockquote);
      postContainer.appendChild(postDiv);
    }
  });

  // Procesowanie iframe dla Instagrama
  const existingScript = document.querySelector('script[src="//www.instagram.com/embed.js"]');
  if (existingScript) {
    existingScript.remove();
  }

  setTimeout(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = "//www.instagram.com/embed.js";
    document.body.appendChild(script);

    script.onload = () => {
      window.instgrm.Embeds.process();
    };
  }, 100);
}




const currentPage = window.location.href;

document.addEventListener('DOMContentLoaded', () => {
  if (currentPage.includes("gallery")) {
    document.getElementById('all').addEventListener('click', () => displayPosts(hashtags.all));
    document.getElementById('cake-artistic').addEventListener('click', () => displayPosts(hashtags.artCakes));
    document.getElementById('cake-meringue').addEventListener('click', () => displayPosts(hashtags.meringue));
    document.getElementById('cake-wedding').addEventListener('click', () => displayPosts(hashtags.wedding));
    document.getElementById('pie').addEventListener('click', () => displayPosts(hashtags.pie));
    document.getElementById('dessert').addEventListener('click', () => displayPosts(hashtags.dessert));
    document.getElementById('candy-bar').addEventListener('click', () => displayPosts(hashtags.candyBar));

    // Domyślne wyświetlanie postów przy ładowaniu strony
    displayPosts(hashtags.all); // Domyślnie bez filtra, wyświetl wszystkie
  }
});

// Funkcja do przewijania na górę strony
class ScrollButton {
  constructor() {
    this.mybutton = document.getElementById("scrollToTopBtn");
    window.onscroll = () => this.scrollFunction();
    if (this.mybutton) {
      this.mybutton.addEventListener("click", () => this.scrollToTop());
    }
  }

  scrollFunction() {
    if (document.body.scrollTop > 2000 || document.documentElement.scrollTop > 2000) {
      this.mybutton.style.display = "block";
      this.mybutton.style.opacity = "1";
    } else {
      this.mybutton.style.opacity = "0";
      this.mybutton.style.display = "none";
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

// Upewnij się, że postContainer istnieje
if (postContainer) {
  // Obserwator zmian DOM
  const observer = new MutationObserver(() => {
    adjustInstagramIframes(); // Dostosuj iframe'y po dodaniu nowych elementów
  });

  observer.observe(postContainer, { childList: true, subtree: true });
} else {
  console.error("Element #post-container nie został znaleziony.");
}

// Funkcja do dostosowywania iframe
function adjustInstagramIframes() {
  const iframes = document.querySelectorAll('iframe');

  iframes.forEach((iframe) => {
    iframe.style.minWidth = '0'; // Próba nadpisania min-width
    iframe.style.width = '100%'; // Pełna szerokość rodzica
  });
}

// Nasłuchiwanie załadowania iframe z Instagrama
window.addEventListener('load', () => {
  adjustInstagramIframes();
});

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.filter__button');
  const defaultButton = document.getElementById('all');

  // Ustawienie domyślnego aktywnego przycisku
  defaultButton.classList.add('active');

  // Obsługa kliknięć i zmiana aktywnego przycisku
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      buttons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
});

export default ScrollButton;
